import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { SaveButton } from "../../../../components/Buttons";

export const EManat = () => {
    document.title = "E-Manat";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ayarlar", value: "/settings" },
        { name: "Ödəniş", value: "/settings/payment" },
        { name: "E-Manat", value: "/settings/payment/emanat", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Emanat ödəmə sistemi ilə ödəniş qaydası</h2>
                    <p>
                        Profil balansını artırmaq üçün Emanat ödəmə sistemində aşağıdakı ardıcıllığa əməl etmək lazımdır
                        <ol>
                            <li>
                                <mark>Emanat</mark> ödəmə sistemində <mark>E-pulqabı ödənişləri</mark> seçimini edin
                            </li>
                            <li>
                                <mark>Bein Systems</mark> seçin.
                            </li>
                            <li>
                                Qeydiyyatdan keçdiyiniz telefon nömrəsini yazın və <SaveButton>irəli</SaveButton> düyməsini sıxın.
                            </li>
                            <li>
                                Əskinazları daxil edin və <SaveButton>ödə</SaveButton> düyməsini sıxın
                            </li>
                        </ol>
                        <b>Qeyd</b>: Ödəniş zamanı komissiya haqqı tutulmur.
                    </p>
                    <img src="/images/settings/payment/emanat.gif" alt="E-Manat" />
                </article>
            </div>
        </div>
    );
};
